// extracted by mini-css-extract-plugin
export default {"speakerItem":"speakerItem__SQHD8R","selected":"selected__GSaXEZ","speakerContent":"speakerContent__bQ3h1n","speakerInfo":"speakerInfo__NmOJJT","speakerMeta":"speakerMeta__BjD5mC"};